/**
 * TG-B — Dexie-backed store for per-transaction progress series. One row per
 * (stationId, transactionId) holding the bounded telemetry buffer captured
 * during charging; written on StopTransaction, read on history drill-in.
 */
import type { StationId } from '@/domain/types';
import type { TxSample } from '@/lib/txTelemetry';
import type { TransactionSamplesRepository } from '@/persistence/ports';
import type { Evse3Database } from '../db';

export class TransactionSamplesRepositoryDexie implements TransactionSamplesRepository {
  constructor(private readonly db: Evse3Database) {}

  async get(stationId: StationId, transactionId: number): Promise<readonly TxSample[] | null> {
    const row = await this.db.transactionSamples.get([stationId, transactionId]);
    return row ? row.samples.map((s) => ({ ...s })) : null;
  }

  async upsert(
    stationId: StationId,
    transactionId: number,
    samples: readonly TxSample[],
  ): Promise<void> {
    await this.db.transactionSamples.put({
      stationId,
      transactionId,
      samples: samples.map((s) => ({
        t: s.t,
        powerW: s.powerW,
        socPct: s.socPct,
        energyWh: s.energyWh,
      })),
    });
  }
}
